import filter from 'lodash/filter';
import keyBy from 'lodash/keyBy';
import { ElasticsearchFilterTypeEnum, CommonFilterEnum } from '@lyearn-team/reporting-library';

export default async function getUsersByIds(reportingLibrary, userIds) {
  const response = await reportingLibrary.getUsersByIds([
    {
      type: ElasticsearchFilterTypeEnum.MUST,
      name: CommonFilterEnum.ID,
      values: userIds
    }
  ]);
  const users = response.users;
  const usersById = keyBy(users, 'id');
  return filter(userIds.map(id => usersById[id]));
}
